// eslint-disable-next-line no-restricted-imports
import { TablePaginationProps } from '@mui/material';
import {
  GridPagination,
  gridPageSizeSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui/Stack';
import { Typography } from 'libs/ui/Typography';
import { Colors } from 'libs/ui/theme';

import { Pagination } from '../../Pagination';

function PaginationComponent({
  page,
  onPageChange,
  className,
}: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>) {
  const apiRef = useGridApiContext();
  const rowCount = apiRef.current.getRowsCount();
  const limit = useGridSelector(apiRef, gridPageSizeSelector);
  if (limit >= rowCount) {
    return null;
  }
  const count = Math.ceil(rowCount / limit);

  return (
    <Pagination
      className={className}
      count={count}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event as any, newPage - 1);
      }}
    />
  );
}

interface Props {
  rowCount: number | undefined;
  limit: number;
  page: number;
}

export function CustomPagination({ limit, page, rowCount }: Props) {
  const { t } = useTranslation();
  return (
    <Stack
      alignItems="center"
      direction="row"
      flex={1}
      justifyContent="space-between"
    >
      {!!rowCount && (
        <Typography color={Colors.gray500} variant="caption">
          {t('components.table.pagination.count', {
            currentCount: Math.min(limit * (page + 1), rowCount),
            allCount: rowCount,
          })}
        </Typography>
      )}
      <GridPagination
        ActionsComponent={PaginationComponent}
        labelDisplayedRows={() => null}
      />
    </Stack>
  );
}
